export var StudyLevelEnum;
(function (StudyLevelEnum) {
    StudyLevelEnum["Any"] = "any";
    StudyLevelEnum["BacProBepCap"] = "bac-pro-bep-cap";
    StudyLevelEnum["Bac"] = "bac";
    StudyLevelEnum["BtsDutBac2"] = "bts-dut-bac-2";
    StudyLevelEnum["LicenseM1Bac34"] = "license-m1-bac-3-4";
    StudyLevelEnum["MasterIngenieurBac5"] = "master-ingenieur-bac-5";
    StudyLevelEnum["DoctoratBac8"] = "doctorat-bac-8";
})(StudyLevelEnum || (StudyLevelEnum = {}));
//# sourceMappingURL=study-level.enum.js.map